import { Button } from 'primereact/button';
import { Divider } from 'primereact/divider';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import React from 'react';
import { useSelector } from 'react-redux';

import trash from '../../../assets/trash.png';
import { selectCurrentUser } from '../../../pages/login/authSlice';
import { IResolveDispute } from '../../../utils/types';
import { useGetDisputeReasonsQuery, useGetResolutionReasonsQuery } from '../disputeSlice';
import DescriptionBox from '../../../components/descriptionBox/DescriptionBox';

type formDisputeProps = {
    dispute: IResolveDispute | null;
    index: number;
    payoutDailyDisputeMetrics: any;
    handleFormChange: (event: any, index: number) => void;
    removeDispute: (index: number) => void;
    ResolveDisputeClick: (index: number) => void;
};

export const EditFormDispute = ({
    dispute,
    index,
    payoutDailyDisputeMetrics,
    handleFormChange,
    removeDispute,
    ResolveDisputeClick,
}: formDisputeProps) => {
    const loggedUser = useSelector(selectCurrentUser);
    const { data: resolutionReasons } = useGetResolutionReasonsQuery({ typeId: 2 });
    const { data: disputeReasonData } = useGetDisputeReasonsQuery({
        typeId: 1,
    });

    return (
        <>
            <Divider className="m-0 pb-4" />
            <div className="col-md-11 pe-0" style={{ width: '95.6%' }}>
                <Button
                    className="p-button text-center w-100 borderRadius"
                    style={{ backgroundColor: `${dispute?.metricHeaderColor}` }}
                    label={`Dispute - ${index + 1}`}
                />

                <div className="row pt-3" key={index}>
                    <div className="col-md-6 pt-1">
                        <div className="row">
                            <div className="col-md-6">
                                <h6>Metric</h6>
                                <Dropdown
                                    disabled={dispute?.disputeId ? dispute?.disputeId > 0 : false}
                                    value={dispute?.metricId}
                                    options={payoutDailyDisputeMetrics?.data}
                                    name="metricId"
                                    optionValue={'metric_id'}
                                    optionLabel={'label'}
                                    onChange={(event) => handleFormChange(event, index)}
                                    placeholder="Select Metric"
                                    className={`borderRadius ${dispute?.metricId === 0 ? 'p-invalid' : ''}`}
                                />

                                <h6 className="mt-3 pt-2">dispute Reason</h6>
                                <Dropdown
                                    disabled={dispute?.resolutionClicked}
                                    name="disputeReasonid"
                                    value={dispute?.disputeReasonid}
                                    options={disputeReasonData?.data}
                                    onChange={(event) => handleFormChange(event, index)}
                                    optionValue={'reason_id'}
                                    optionLabel={'reason_name'}
                                    placeholder="Select Reason"
                                    className={`borderRadius ${
                                        dispute?.disputeReasonid === 0 ? 'p-invalid' : ''
                                    }`}
                                />
                            </div>
                            <div className="col-md-6">
                                <h6>Disputed Value</h6>
                                <InputText
                                    name="disputedValue"
                                    disabled
                                    value={dispute?.disputedValue}
                                    onChange={(event) => handleFormChange(event, index)}
                                    className="borderRadius"
                                />

                                <h6 className="mt-3 pt-2">Expected Value</h6>
                                <InputText
                                    name="proposedValue"
                                    disabled={dispute?.resolutionClicked}
                                    value={dispute?.proposedValue}
                                    keyfilter={/^([/.0-9]|[/.0-9]?%)$/}
                                    //keyfilter={/^([0/.00-9/.99]|[0/.00-9/.99]?%)/}
                                    onChange={(event) => handleFormChange(event, index)}
                                    className={`borderRadius`}
                                />
                            </div>
                        </div>
                        <div className="col-md-12">
                            {dispute?.resolutionClicked === true ? (
                                <>
                                    <h6 className="mt-3 pt-2">Resolution Reason</h6>
                                    <Dropdown
                                        name="resolutionReasonId"
                                        value={dispute?.resolutionReasonId}
                                        options={resolutionReasons?.data}
                                        onChange={(event) => handleFormChange(event, index)}
                                        optionLabel="reason_name"
                                        optionValue="reason_id"
                                        placeholder="Select Reason"
                                        className={`borderRadius ${
                                            dispute?.resolutionReasonId === 0 ? 'p-invalid' : ''
                                        }`}
                                    />
                                </>
                            ) : (
                                ''
                            )}
                        </div>
                    </div>
                    <div className="col-md-6">
                        <DescriptionBox
                            title="Associate Comment"
                            value={dispute?.disputeComment}
                            responseDescription={dispute?.disputeComment}
                            disabled={dispute?.resolutionClicked}
                            limit={4000}
                            className={`borderRadius ${dispute?.disputeComment === '' ? 'p-invalid' : ''}`}
                            onChange={(value) => {
                                const syntheticEvent = {
                                    target: {
                                        name: 'disputeComment',
                                        value,
                                    },
                                };
                                handleFormChange(syntheticEvent, index);
                            }}
                        />
                        {dispute?.resolutionClicked === true ? (
                            <>
                                <DescriptionBox
                                    title="Resolution Comment"
                                    value={dispute?.resolutionComment}
                                    responseDescription={dispute?.resolutionComment}
                                    limit={4000}
                                    className={`borderRadius ${
                                        dispute?.resolutionComment === '' ||
                                        dispute?.resolutionComment === null
                                            ? 'p-invalid'
                                            : ''
                                    }`}
                                    onChange={(value) => {
                                        const syntheticEvent = {
                                            target: {
                                                name: 'resolutionComment',
                                                value,
                                            },
                                        };
                                        handleFormChange(syntheticEvent, index);
                                    }}
                                />
                                <div className="row disputeCommentFooterText">
                                    <div className="col-md-6">
                                        {new Date().toLocaleString('en-US', {
                                            dateStyle: 'medium',
                                        })}
                                    </div>
                                    <div className="col-md-6 text-end">Added by {loggedUser}.</div>
                                </div>
                            </>
                        ) : (
                            ''
                        )}
                        {dispute?.resolutionClicked === false ? (
                            <Button
                                type="button"
                                visible={dispute?.disputeId > 0}
                                className="btn-export w-auto float-end mt-3"
                                icon="pi pi-check-circle"
                                label="Resolve Dispute"
                                style={{ width: '175px', float: 'right' }}
                                onClick={() => {
                                    ResolveDisputeClick(index);
                                }}
                            />
                        ) : (
                            ''
                        )}
                    </div>
                </div>
            </div>

            {dispute?.disputeId === 0 ? (
                <div className="col-md-1 p-0 text-end" style={{ width: '4.4%' }}>
                    <img
                        src={trash}
                        id="gg"
                        onClick={() => removeDispute(index)}
                        onKeyDown={() => removeDispute(index)}
                        alt="Delete dispute?"
                        role="presentation"
                    />
                </div>
            ) : (
                ''
            )}
        </>
    );
};
